module.exports = __webpack_public_path__ + "static/img/erws.7aa257e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erws.png
// module id = wHmu
// module chunks = 1